import { useState } from 'react';

interface CustomImageProps {
  src?: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const CustomImage = ({ src, className = '', style, alt, ...rest }: CustomImageProps) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className={`relative aspect-video w-full ${className}`}>
      <img
        src={src}
        alt={alt}
        className={`absolute inset-0 h-full w-full object-cover ${className} `}
        onLoad={() => setIsLoading(false)}
        style={{ display: isLoading ? 'none' : 'block', ...style }}
        {...rest}
      />
      {isLoading && <div className={`absolute inset-0 aspect-video w-full animate-pulse bg-[#F0F7F6] ${className}`} />}
    </div>
  );
};
